
import { useStore } from "../../state/state.ts";
import Statistics from "../statistics.tsx";
export default function StatisticsHeizkosten() {
  const annual_heating_costs_adjusted = useStore((state)=>state.annual_heating_costs_adjusted ?? 0);
  const annual_heating_costs_planned = useStore((state)=>state.annual_heating_costs_planned ?? 0);

  if (annual_heating_costs_adjusted == 0 && annual_heating_costs_planned == 0 ) {return <></>; }
  return (
    <Statistics label={"Heizkosten"} now={annual_heating_costs_adjusted} future={annual_heating_costs_planned} unit={"€/Jahr"} />
  )
}